// extracted by mini-css-extract-plugin
export default {"container":"SeriesNftSelectDnd_container__4UWMy"};